export function registrationSuccessView(message: string): {
  title: string;
  showVerificationPrompt: boolean;
} {
  const updated = /was updated/i.test(message);
  return {
    title: updated ? "Application updated" : "Registration successful",
    showVerificationPrompt: /please verify your email|check your email to verify/i.test(message),
  };
}
